import {Component, Input, OnChanges, OnInit, SimpleChanges} from "@angular/core";
import {FUIFormationService, GroupTemplate} from "../formation.service";
import {FUIFormationType} from "../formation.type";

@Component({
    selector: "fui-formation-groups",
    styleUrls: ["./formation-groups.component.scss"],
    templateUrl: "./formation-groups.component.html"
})
export class FUIFormationGroupsComponent implements OnInit {
    private _formationType: FUIFormationType;

    constructor(public formationService: FUIFormationService) {
    }

    ngOnInit(): void {
        this.formationService.notifyInitialised();
    }

    trackByFn(index: number, item: GroupTemplate): any {
        return item.title;
    }

    @Input()
    get formationType(): FUIFormationType {
        return this._formationType;
    }

    set formationType(value: FUIFormationType) {
        this._formationType = value;
        this.formationService.formationType = this._formationType;
    }

    isPromise(value: any) {
        return value instanceof Promise;
    }
}
